import React, { type FC, useEffect, useRef } from 'react'
import { FormattedMessage } from 'react-intl'
import { BoxDetails } from '../components/BoxDetails'
import { useBoxById } from '../hooks/useBoxes'
import { BoxesLayout as BoxLayout } from '../layout/BoxesLayout'
import { Loader } from '../ui/Loader'
import { useParams, useSearchParams, useLocation } from 'react-router'
import { trackBoxViewed } from '../utils/amplitude'

type BoxViewSource = 'feed' | 'direct' | 'referral' | 'search'

export const SingleBoxPage: FC = () => {
  const { address } = useParams()
  const [searchParams] = useSearchParams()
  const location = useLocation()
  const hasTrackedView = useRef(false)

  if (!address) {
    throw new Error('Box address is required')
  }

  const { data: box, isFetching, refetch, isError } = useBoxById(address)

  // Track box view when box data is loaded
  useEffect(() => {
    if (box && !hasTrackedView.current) {
      hasTrackedView.current = true
      // Determine source: navigation state > URL params > default
      const stateSource = (location.state as { source?: BoxViewSource })?.source
      const refParam = searchParams.get('ref')
      const source: BoxViewSource = stateSource ?? (refParam ? 'referral' : 'direct')
      trackBoxViewed(address, source)
    }
  }, [box, address, searchParams, location.state])

  if (isFetching && !box) {
    return <Loader />
  }

  if (!box || isError) {
    return (
      <FormattedMessage id="box-not-found" defaultMessage="Опрос не найден" />
    )
  }

  return (
    <BoxLayout
      loading={isFetching && !box}
      error={isError}
      onRetryFetch={refetch}
      titleElement={null}
      tabsElement={null}
    >
      <BoxDetails box={box} />
    </BoxLayout>
  )
}

export const singleBoxPagePath = '/box/:address'
export const singleBoxPageBoxPath = '/box/'
